export default __webpack_public_path__ + "static/Plain-Light-9f3ce27222c8933391dc1e03e8150e97.woff";